import { render, staticRenderFns } from "./CampaignCoupon.vue?vue&type=template&id=45b9c93a&scoped=true&"
import script from "./CampaignCoupon.vue?vue&type=script&lang=js&"
export * from "./CampaignCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCoupon.vue?vue&type=style&index=0&id=45b9c93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9c93a",
  null
  
)

export default component.exports